import { createAction } from 'redux-act';

export const putData = createAction('exam put data');
export const failPutData = createAction('exam fail put data');
export const successPutData = createAction('exam success put data');

export const setData = createAction('exam set data');

export const checkEmail = createAction('check email');
export const successCheckEmail = createAction('success check email');
export const failCheckEmail = createAction('fail check email');

export const checkUser = createAction('check user');
export const successCheckUser = createAction('success check user');
export const failCheckUser = createAction('fail check user');

export const reAnswer = createAction('reanswer');
export const successReanswer = createAction('success reanswer');
export const failReAnswer = createAction('fail reanswer');



// WEBPACK FOOTER //
// ./src/actions/exam.js